import Header from '../../../header';
import { Card } from '../../Card';
import OrganizationUserManagementTab from '../organizations/UserManagementTab';
import AdminHeader from './AdminHeader';
import { useCurrentOrganization } from 'src/contexts/OrganizationContext';

const UserManagement = () => {
  const organization = useCurrentOrganization();

  return (
    <div className="min-h-screen bg-gray-100">
      <Header isAdminPage={true} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <AdminHeader
          title="User Management"
          description="Manage users and roles for your organization"
          organization={organization}
        />

        <Card className="w-full p-8">
          <OrganizationUserManagementTab organization={organization} />
        </Card>
      </div>
    </div>
  );
};

export default UserManagement;
